import React from "react";
import ContactInfoCard from "../../cards/ContactInfoCard";
import { IoCall, IoLocationSharp } from "react-icons/io5";
import { GrMail } from "react-icons/gr";
import { MdAccessTimeFilled } from "react-icons/md";
import ContactDetails from "../../static-data/ContactDetails.json";

const ContactInfo = () => {
  return (
    <div className="space-y-8">
      {" "}
      <ContactInfoCard
        contactType="Call Us"
        contactDetails={ContactDetails.phone}
        icon={<IoCall className="text-xl" />}
      />
      <ContactInfoCard
        contactType="Find Us"
        contactDetails={ContactDetails.address}
        icon={<IoLocationSharp className="text-xl" />}
      />
      <ContactInfoCard
        contactType="Mail Us"
        contactDetails={ContactDetails.email}
        icon={<GrMail className="text-xl" />}
      />
      <ContactInfoCard
        contactType="Available Time"
        contactDetails={ContactDetails.phone}
        icon={<MdAccessTimeFilled className="text-xl" />}
      />
    </div>
  );
};

export default ContactInfo;
